import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './Checkbox.scss';
import clsx from 'clsx';

export default function Checkbox({ defaultChecked, onChange, className }) {
  const [checked, setChecked] = useState(defaultChecked);
  const toggle = () => setChecked(!checked);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  useEffect(() => {
    onChange(checked);
  }, [checked]);

  return (
    <div className={clsx('custom-checkbox', className)} onClick={toggle}>
      {checked && <div className="checked" />}
    </div>
  );
}
Checkbox.defaultProps = {
  defaultChecked: false,
  onChange: () => {},
  className: '',
};

Checkbox.propTypes = {
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};
